import React from 'react';
import { motion } from 'framer-motion';
import { XIcon, CheckIcon } from 'lucide-react';
export function ComparisonTable() {
  const badPoints = [{
    emoji: '❌',
    title: 'Mezclar mal la resina',
    desc: 'Proporciones incorrectas.'
  }, {
    emoji: '🫧',
    title: 'No eliminar las burbujas',
    desc: 'Acabado poco profesional.'
  }, {
    emoji: '🌡️',
    title: 'Ignorar la temperatura',
    desc: 'Grietas y deformaciones.'
  }, {
    emoji: '⏳',
    title: 'No respetar el curado',
    desc: 'Pieza arruinada.'
  }, {
    emoji: '💸',
    title: 'Comprar sin conocimiento',
    desc: 'Pérdida de dinero.'
  }, {
    emoji: '🪵',
    title: 'No sellar la madera',
    desc: 'Mayor desperdicio de resina.'
  }];
  const goodPoints = [{
    emoji: '✨',
    title: 'Acabados de nivel profesional',
    desc: 'Resultados que impresionan.'
  }, {
    emoji: '💰',
    title: 'Convertí tu hobby en ingresos',
    desc: 'Creá piezas para vender.'
  }, {
    emoji: '🚀',
    title: 'Aprendé paso a paso',
    desc: 'Sin perder tiempo.'
  }, {
    emoji: '🎯',
    title: 'Dominá la resina epóxica',
    desc: 'Como un profesional.'
  }, {
    emoji: '💎',
    title: 'Piezas con efecto premium',
    desc: 'Brillo y calidad.'
  }, {
    emoji: '🛠️',
    title: 'Técnicas que sí funcionan',
    desc: 'Aplicadas en proyectos reales.'
  }, {
    emoji: '🌊',
    title: 'Diseños únicos y modernos',
    desc: 'Que llaman la atención.'
  }];
  return <section className="py-12 px-4 relative z-10 bg-[#fdf8f3] pt-[0px] pb-[0px] space-y-[0px]" data-id="element-73" data-mp="36lkzm2pns58u">
      <div className="max-w-6xl mx-auto" data-id="element-74" data-mp="31njhbk0249yf">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-white border border-gray-200 rounded-2xl p-8 md:p-10 shadow-sm" data-id="element-75" data-mp="3gka7r3rr6bbw">
          <div className="mb-8 border-b border-gray-100 pb-6 relative z-10" data-id="element-76" data-mp="3noidavd7d4ic">
            <div className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-md bg-red-500/10 text-red-600 text-xs font-bold mb-3" data-id="element-77" data-mp="3sm1qrt22td98">
              <XIcon className="w-3 h-3" data-id="element-78" data-mp="18nt6tb827i4" /> EL ERROR
            </div>
            <h3 className="text-2xl font-bold text-gray-800" data-id="element-79" data-mp="67ifw6cb8g7i">
              Principiante sin guía
            </h3>
            <p className="text-gray-500 mt-2 text-sm" data-id="element-80" data-mp="a7j42ip7o5rr">
              Arruina piezas y desperdicia resina
            </p>
          </div>
          <ul className="space-y-5" data-id="element-81" data-mp="f5kl6y32tv0l">
            {badPoints.map((point, i) => <li key={i} className="flex items-start gap-4 text-gray-600" data-id="element-82" data-mp="k68b1gfkk5t8" data-mpi={i}>
                <motion.div animate={{
              scale: [1, 1.2, 1]
            }} transition={{
              duration: 2,
              repeat: Infinity,
              ease: 'easeInOut',
              delay: i * 0.3
            }} className="bg-red-500/10 p-1.5 rounded-lg shrink-0 mt-0.5 flex items-center justify-center w-8 h-8" data-id="element-83" data-mp="2h021b4gxfywt">
                  <span className="text-sm" data-id="element-84" data-mp="24mg7oyz4ekuy">{point.emoji}</span>
                </motion.div>
                <div className="flex flex-col" data-id="element-85" data-mp="1znv2sm8xbd06">
                  <span className="font-bold text-gray-800" data-id="element-86" data-mp="2xceyaysyqq1q">{point.title}</span>
                  <span className="text-sm text-gray-500" data-id="element-87" data-mp="2sdty2zdpo6da">{point.desc}</span>
                </div>
              </li>)}
          </ul>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.2
      }} className="bg-white border border-[#d97706]/30 rounded-2xl p-8 md:p-10 relative overflow-hidden shadow-[0_8px_30px_rgba(217,119,6,0.05)]" data-id="element-88" data-mp="2nhd6twb7tbvz">
          {/* Glow effect */}
          <div className="absolute -top-24 -right-24 w-48 h-48 bg-[#d97706]/10 rounded-full blur-3xl" data-id="element-89" data-mp="30n97l737chth" />

          <div className="mb-8 border-b border-gray-100 pb-6 relative z-10" data-id="element-90" data-mp="2luxja3vqjppv">
            <div className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-md bg-[#d97706]/10 text-[#d97706] text-xs font-bold mb-3" data-id="element-91" data-mp="2qwmw9p2iqdgl">
              <CheckIcon className="w-3 h-3" data-id="element-92" data-mp="3jksh0btko2gf" /> EL OBJETIVO
            </div>
            <h3 className="text-2xl font-bold text-gray-900" data-id="element-93" data-mp="3jk0urrlv7h2t">
              Maestro de la Resina
            </h3>
            <p className="text-gray-600 mt-2 text-sm" data-id="element-94" data-mp="34pw0lbbm08s9">
              Crea piezas de lujo que impactan
            </p>
          </div>
          <ul className="space-y-5 relative z-10" data-id="element-95" data-mp="1t7uwg90f93fg">
            {goodPoints.map((point, i) => <li key={i} className="flex items-start gap-4 text-gray-800 font-medium" data-id="element-96" data-mp="1y7z7hjik95ya" data-mpi={i}>
                <motion.div animate={{
              scale: [1, 1.2, 1]
            }} transition={{
              duration: 2,
              repeat: Infinity,
              ease: 'easeInOut',
              delay: i * 0.3
            }} className="bg-[#d97706]/10 p-1.5 rounded-lg shrink-0 mt-0.5 flex items-center justify-center w-8 h-8" data-id="element-97" data-mp="g89muqb8kgsl">
                  <span className="text-sm" data-id="element-98" data-mp="3oq62qfsm0xr1">{point.emoji}</span>
                </motion.div>
                <div className="flex flex-col" data-id="element-99" data-mp="6bepiaqp8mfw">
                  <span className="font-bold text-gray-900" data-id="element-100" data-mp="6d7uzmpkt0mb">{point.title}</span>
                  <span className="text-sm text-gray-600" data-id="element-101" data-mp="1jvk0fdtksc1">{point.desc}</span>
                </div>
              </li>)}
          </ul>
        </motion.div>
      </div>
    </section>;
}